<template>
  <div class="remote_bottom_nav" :class="arrowProps ? '' : 'hidden_remote_bottom_nav'">
    <div class="remote_arrow_bottom" :class="arrowProps ? '' : 'hidden'" @click="clickArrowBtn(false)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 12 12"
           style="transform: rotate(90deg);">
        <path fill="#fff" d="M5 10.243L3.586 8.828 6.414 6 3.586 3.172 5 1.757 9.243 6 5 10.243z"/>
      </svg>
    </div>
    <div class="remote_arrow_top" :class="arrowProps ? 'hidden' : ''" @click="clickArrowBtn(true)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 12 12"
           style="transform: rotate(270deg);">
        <path fill="#fff" d="M5 10.243L3.586 8.828 6.414 6 3.586 3.172 5 1.757 9.243 6 5 10.243z"/>
      </svg>
    </div>

    <div class="btn_box">
      <div class="remote_btn_mic" @click="clickMicBtn()">
        <svg :class="muteProps ? 'hidden' : ''" xmlns="http://www.w3.org/2000/svg" width="54" height="54" fill="none"
             viewBox="0 0 54 54">
          <path fill="#444" fill-rule="evenodd"
                d="M23 15h8v17h-8V15zm-2 0c0-1.105.895-2 2-2h8c1.105 0 2 .895 2 2v17c0 1.105-.895 2-2 2h-8c-1.105 0-2-.895-2-2V15zm-2 18v-2h-2v2c0 2.761 2.239 5 5 5h4v2h-3v2h8v-2h-3v-2h4c2.761 0 5-2.239 5-5v-2h-2v2c0 1.657-1.343 3-3 3H22c-1.657 0-3-1.343-3-3z"
                clip-rule="evenodd"/>
        </svg>

        <!-- 마이크 muted 경우 아이콘 -->
        <svg :class="muteProps ? '' : 'hidden'" xmlns="http://www.w3.org/2000/svg" width="54" height="54" fill="none"
             viewBox="0 0 54 54">
          <path fill="#444" fill-rule="evenodd"
                d="M19.732 12L18 13l17.5 30.31 1.732-1-2.84-4.918C35.946 36.544 37 34.895 37 33v-2h-2v2c0 1.155-.652 2.157-1.609 2.659l-1.189-2.06c.485-.365.798-.946.798-1.599V15c0-1.105-.895-2-2-2h-8c-.885 0-1.635.575-1.9 1.371L19.733 12zM23 17.66l8 13.857V15h-8v2.66zM21 32V21.66l2 3.464V32h3.97l1.154 2H23c-1.105 0-2-.895-2-2zm1 4h7.28l1.154 2H28v2h3v2h-8v-2h3v-2h-4c-2.761 0-5-2.239-5-5v-2h2v2c0 1.657 1.343 3 3 3z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <span style="color: var(--white);" :class="muteProps ? 'hidden' : ''" class="no-drag">{{ $t('status.mic_on') }}</span>
      <span style="color: var(--white);" :class="muteProps ? '' : 'hidden'" class="no-drag">{{ $t('status.mic_off') }}</span>
    </div>
    <div class="btn_box">
      <div class="remote_btn_video" @click="clickVideoBtn()">
        <svg :class="cameraProps? '' : 'hidden'" xmlns="http://www.w3.org/2000/svg" width="54" height="54" fill="none"
             viewBox="0 0 54 54">
          <path fill="#444" fill-rule="evenodd"
                d="M16 22h15v10H16V22zm17 8.889V34H14V20h19v3.111L40 20v14l-7-3.111zm0-2.189l5 2.223v-7.845L33 25.3v3.4z"
                clip-rule="evenodd"/>
        </svg>
        <svg :class="cameraProps? 'hidden' : ''" xmlns="http://www.w3.org/2000/svg" width="54" height="54" fill="none"
             viewBox="0 0 54 54">
          <path fill="#444" fill-rule="evenodd"
                d="M18.732 11L17 12l17.5 30.31 1.732-1-4.22-7.31H33v-3.111L40 34V20l-7 3.111V20h-9.072l-5.196-9zm6.35 11l5.774 10H31V22h-5.917zM14 20h5.619l1.154 2H16v10h10.547l1.155 2H14V20zm19 8.7l5 2.223v-7.845L33 25.3v3.4z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <span style="color: var(--white);" :class="cameraProps ? '' : 'hidden'" class="no-drag">{{ $t('status.camera_on') }}</span>
      <span style="color: var(--white);" :class="cameraProps ? 'hidden' : ''"
            class="no-drag">{{ $t('status.camera_off') }}</span>
    </div>
    <div class="btn_box">
      <div class="remote_btn_volume" @click="clickVolumeBtn()">
        <svg :class="volumeProps ? '' : 'hidden'" xmlns="http://www.w3.org/2000/svg" width="54" height="54" fill="none"
             viewBox="0 0 54 54">
          <path fill="#444" fill-rule="evenodd"
                d="M18 24h4.92L27 19.24v15.52L22.92 30H18v-6zm-2-2h6l6-7h1v24h-1l-6-7h-6V22zm24 5c0-3.776-2.092-7.063-5.181-8.764l-.938 1.767C36.338 21.368 38 23.99 38 27c0 3.115-1.781 5.814-4.38 7.136l.938 1.767C37.79 34.245 40 30.88 40 27zm-5 0c0 1.966-1.135 3.668-2.786 4.485l-.939-1.769C32.295 29.236 33 28.201 33 27c0-1.096-.587-2.055-1.465-2.578l.939-1.768C33.983 23.514 35 25.139 35 27z"
                clip-rule="evenodd"/>
        </svg>
        <!-- 스피커 volume off인 경우 아이콘 -->
        <svg :class="volumeProps ? 'hidden' : ''" xmlns="http://www.w3.org/2000/svg" width="54" height="54" fill="none"
             viewBox="0 0 54 54">
          <path fill="#444" fill-rule="evenodd"
                d="M34.819 18.236C37.908 19.937 40 23.224 40 27c0 3.88-2.21 7.245-5.44 8.903l-.939-1.767c2.599-1.322 4.38-4.021 4.38-7.136 0-3.01-1.663-5.632-4.12-6.997l.938-1.767zm-2.605 13.248C33.864 30.668 35 28.966 35 27c0-1.861-1.017-3.485-2.526-4.346l-.939 1.768C32.413 24.945 33 25.904 33 27c0 1.2-.706 2.237-1.725 2.716l.939 1.768z"
                clip-rule="evenodd"/>
          <path fill="#444" d="M16 13H18V48H16z" transform="rotate(-30 16 13)"/>
          <path fill="#444" fill-rule="evenodd"
                d="M19.196 22H16v10h6l6 7h1v-.02l-3.338-5.78L22.92 30H18v-6h2.35l-1.154-2zM27 31.517V19.24L22.92 24h-.26l-1.154-2H22l6-7h1v19.98l-2-3.463z"
                clip-rule="evenodd"/>
        </svg>
      </div>
      <span style="color: var(--white);" :class="volumeProps ? '' : 'hidden'"
            class="no-drag">{{ $t('status.speaker_on') }}</span>
      <span style="color: var(--white);" :class="volumeProps ? 'hidden' : ''"
            class="no-drag">{{ $t('status.speaker_off') }}</span>
    </div>

<!--    <div class="btn_box">-->
<!--      <div class="remote_btn_volume" @click="clickChangeBtn()">-->
<!--        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.99 7.27675C21 7.28675 21 7.29674 21 7.30674C21 7.43668 20.97 7.56661 20.92 7.67656C20.8801 7.76651 20.8301 7.83648 20.7701 7.90644C20.7635 7.91644 20.7579 7.92643 20.7524 7.93643C20.7413 7.95642 20.7302 7.97641 20.7102 7.9964L17.472 11.2748C17.2821 11.4747 17.0222 11.5746 16.7624 11.5746C16.5125 11.5746 16.2626 11.4747 16.0627 11.2848C15.673 10.905 15.663 10.2653 16.0527 9.87548L17.6119 8.29625L4.00944 8.28626C3.45974 8.28626 3.00999 7.83648 3.00999 7.28675C3.00999 6.73702 3.45974 6.28724 4.00944 6.28724L17.6119 6.29724L16.0428 4.68803C15.663 4.29822 15.673 3.66853 16.0627 3.27872C16.4525 2.89891 17.0822 2.9089 17.472 3.29871L20.7102 6.60708C20.7252 6.62208 20.7351 6.63957 20.7451 6.65706C20.7551 6.67455 20.7651 6.69204 20.7801 6.70703C20.7907 6.72178 20.8016 6.73653 20.8127 6.75136C20.854 6.80693 20.8964 6.86382 20.92 6.92693C20.97 7.03687 20.99 7.15681 20.99 7.27675ZM6.38812 15.7126L20.0006 15.7026C20.5502 15.7026 21 16.1424 20.99 16.7121C20.99 17.2618 20.5403 17.7116 19.9906 17.7116L6.38812 17.7216L7.94725 19.3008C8.33704 19.6906 8.32704 20.3203 7.93726 20.7101C7.74736 20.9001 7.48751 21 7.23764 21C6.97779 21 6.72793 20.9001 6.52804 20.7001L3.28984 17.4218C3.26985 17.4084 3.25875 17.3862 3.24764 17.364C3.24209 17.3529 3.23653 17.3418 3.22987 17.3318C3.16991 17.2618 3.11993 17.1919 3.07995 17.1019C3.02998 16.982 3 16.852 3 16.7221C3 16.7171 3.0025 16.7121 3.005 16.7071C3.00749 16.7021 3.00999 16.6971 3.00999 16.6921C3.00999 16.5722 3.02998 16.4522 3.07995 16.3423C3.11993 16.2523 3.16991 16.1824 3.22987 16.1124C3.23653 16.1024 3.24209 16.0924 3.24764 16.0824C3.25874 16.0624 3.26985 16.0424 3.28984 16.0225L3.29983 16.0125L6.52804 12.7141C6.90783 12.3143 7.54747 12.3043 7.93726 12.6941C8.33703 13.0739 8.34703 13.7136 7.95725 14.1034L6.38812 15.7126Z" fill="#3B3A39"/>-->
<!--        </svg>-->
<!--      </div>-->
<!--      <span-->
<!--          style="color: var(&#45;&#45;white);"-->
<!--          class="no-drag">-->
<!--        좌우반전-->
<!--        &lt;!&ndash;        {{ $t('status.speaker_on') }}&ndash;&gt;-->
<!--      </span>-->
<!--    </div>-->
  </div>
</template>
<script>
export default {
  name: 'deviceControlNav',
  props: ['arrowProps', 'muteProps', 'cameraProps', 'volumeProps'],
  methods: {
    clickArrowBtn(boolean) {
      this.$emit('clickArrowBtn', boolean);
    },
    clickMicBtn(boolean) {
      this.$emit('clickMicBtn', boolean);
    },
    clickVideoBtn(boolean) {
      this.$emit('clickVideoBtn', boolean);
    },
    clickVolumeBtn(boolean) {
      this.$emit('clickVolumeBtn', boolean);
    },
    clickChangeBtn(boolean) {
      this.$emit('clickChange', boolean);
    }
  }
}
</script>